

































































































































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import mapApi from '@/api/map'
import adminPanelApi from '@/api/admin-panel'
import {IInteractiveMap, MapDistrictDto, MapPointDto, MapRegionDto, SelectOption} from "@/global";
import * as enums from '@/global-enum'
import InteractiveMap from "@/components/InteractiveMap.vue";

@Component({
    components: {
        InteractiveMap
    }
})
export default class AdminPanel_EditMap extends Vue {
    isLoading = true;
    isButtonsDisabled = false;

    mapRegionId: number | null = null;
    mapDistrictId: number | null = null;
    mapPointId: number | null = null;

    mapRegionOptions: SelectOption[] = [];
    mapDistrictOptions: SelectOption[] = [];
    mapPointOptions: SelectOption[] = [];

    mapRegionDtos: MapRegionDto[] = [];

    selectedMapRegionDto: MapRegionDto | null = null;
    selectedMapDistrictDto: MapDistrictDto | null = null;
    selectedMapPointDto: MapPointDto | null = null;

    availableMapPointTypeOptions: SelectOption[] = [];

    mounted() {
        this.updateMapDtos();
    }

    get selectedRegionFullName() {
        return this.$appUtils.getMapElementName(enums.MapElementType_Region, this.selectedMapRegionDto)
    }

    get selectedDistrictFullName() {
        return this.$appUtils.getMapElementName(enums.MapElementType_District, this.selectedMapDistrictDto)
    }

    get selectedPointFullName() {
        return this.$appUtils.getMapElementName(enums.MapElementType_Point, this.selectedMapPointDto)
    }

    @Watch("selectedMapRegionDto", { deep: true })
    onSelectedMapRegionDtoChanged() {
        if (this.$helpers.isExists(this.selectedMapRegionDto)) {
            const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

            // update preview
            interactiveMap.changeMapRegionData(this.selectedMapRegionDto!);
        }
    }

    @Watch("selectedMapDistrictDto", { deep: true })
    onSelectedMapDistrictDtoChanged() {
        if (this.$helpers.isExists(this.selectedMapDistrictDto)) {
            const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

            // update preview
            interactiveMap.changeMapDistrictData(this.selectedMapDistrictDto!);
        }
    }

    @Watch("selectedMapPointDto", { deep: true })
    onSelectedMapPointDtoChanged() {
        if (this.$helpers.isExists(this.selectedMapPointDto)) {
            const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

            // update preview
            interactiveMap.changeMapPointData(this.selectedMapPointDto!);
        }
    }

    onSelectedMapPointDtoCreated(mapPoint: MapPointDto) {
        if (this.$helpers.isExists(mapPoint)) {
            const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

            // update preview
            interactiveMap.addMapPointData(mapPoint);
        }
    }

    onSelectedMapPointDtoDeleted(mapPoint: MapPointDto) {
        if (this.$helpers.isNumeric(mapPoint)) {
            const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

            // update preview
            interactiveMap.removeMapPointData(mapPoint);
        }
    }

    updateAvailableMapPointTypes() {
        this.availableMapPointTypeOptions = [];

        if (this.$helpers.isExists(this.selectedMapPointDto)) {
            if (this.$helpers.isExists(this.selectedMapDistrictDto)) {
                this.availableMapPointTypeOptions = [
                    { id: enums.MapPointType_District, label: "Район" },
                    { id: enums.MapPointType_Region, label: "Область + Район" },
                ];
            } else {
                this.availableMapPointTypeOptions = [
                    { id: enums.MapPointType_Region, label: "Область" },
                    { id: enums.MapPointType_TopLevel, label: "Україна + Область" },
                    { id: enums.MapPointType_TopLevelSpecial, label: "Україна + Область (розмір+)" },
                ];
            }
        }
    }

    isValidationScopeValid(scope: string) {
        return this.$appUtils.vvIsValidationScopeValid(this, scope);
    }

    validateState(ref: string, scope?: string) {
        return this.$appUtils.vvValidateState(this, ref, scope);
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    updateMapPreview() {
        const interactiveMap = this.$refs.interactiveMap as unknown as IInteractiveMap;

        if (this.$helpers.isNumeric(this.mapPointId)) {
            interactiveMap.changeMap(this.mapRegionId, this.mapDistrictId, null);
        } else if (this.$helpers.isNumeric(this.mapDistrictId)) {
            interactiveMap.changeMap(this.mapRegionId, null, null);
        } else {
            interactiveMap.changeMap(null, null, null);
        }
    }

    async onMapSelectionChanged(isRegionChanged: boolean, isDistrictChanged: boolean) {
        if (isRegionChanged) {
            if (this.$helpers.isNumeric(this.mapDistrictId)) {
                this.mapDistrictId = null;
            }
            if (this.$helpers.isNumeric(this.mapPointId)) {
                this.mapPointId = null;
            }
        }
        else if (isDistrictChanged) {
            if (this.$helpers.isNumeric(this.mapPointId)) {
                this.mapPointId = null;
            }
        }

        this.updateMapOptions();

        this.updateSelectedMapDtos();

        this.updateMapPreview();
    }

    async updateMapDtos() {
        this.isLoading = true;

        return mapApi.allMapRegions(mapRegionDtos => {
            this.mapRegionDtos = mapRegionDtos;

            this.updateMapOptions();

            this.isLoading = false;
        }, this.showError);
    }

    updateSelectedMapDtos() {
        if (this.$helpers.isNumeric(this.mapRegionId)) {
            this.selectedMapRegionDto = this.$helpers.findFirstInArray(this.mapRegionDtos, x => x.id === this.mapRegionId);

            if (this.$helpers.isExists(this.selectedMapRegionDto)) {
                if (this.$helpers.isNumeric(this.mapDistrictId)) {
                    this.selectedMapDistrictDto = this.$helpers.findFirstInArray(this.selectedMapRegionDto!.mapDistricts, x => x.id === this.mapDistrictId);
                } else {
                    this.selectedMapDistrictDto = null;
                }

                if (this.$helpers.isNumeric(this.mapPointId)) {
                    if (this.$helpers.isExists(this.selectedMapDistrictDto)) {
                        this.selectedMapPointDto = this.$helpers.findFirstInArray(this.selectedMapDistrictDto!.mapPoints, x => x.id === this.mapPointId);
                    } else {
                        this.selectedMapPointDto = this.$helpers.findFirstInArray(this.selectedMapRegionDto!.mapPoints, x => x.id === this.mapPointId);
                    }

                    this.updateAvailableMapPointTypes();
                } else {
                    this.selectedMapPointDto = null;
                }
            }
        } else {
            this.selectedMapRegionDto = null;
        }
    }

    updateMapOptions() {
        const thisInst = this;

        this.$appUtils.generateMapSelectOptionsFromDtos(this.mapRegionDtos, this.mapRegionId, this.mapDistrictId, (mapRegions, mapDistricts, mapPoints) => {
            thisInst.mapRegionOptions = mapRegions;
            thisInst.mapDistrictOptions = mapDistricts;
            thisInst.mapPointOptions = mapPoints;
        });
    }

    getMapPercValueView(percValue: number | null) {
        if (!this.$helpers.isNumeric(percValue)) return null;

        return this.$helpers.roundDecimal(percValue! * 100, 2);
    }

    setSelectedMapRegionPercValue(percValue: number | null, isX: boolean) {
        if (!this.$helpers.isNumeric(percValue)) return;
        if (!this.$helpers.isExists(this.selectedMapRegionDto)) return;

        if (isX) {
            this.selectedMapRegionDto!.centerOffsetXPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        } else {
            this.selectedMapRegionDto!.centerOffsetYPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        }
    }

    setSelectedMapDistrictPercValue(percValue: number | null, isX: boolean) {
        if (!this.$helpers.isNumeric(percValue)) return;
        if (!this.$helpers.isExists(this.selectedMapDistrictDto)) return;

        if (isX) {
            this.selectedMapDistrictDto!.centerOffsetXPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        } else {
            this.selectedMapDistrictDto!.centerOffsetYPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        }
    }

    setSelectedMapPointPercValue(percValue: number | null, isX: boolean) {
        if (!this.$helpers.isNumeric(percValue)) return;
        if (!this.$helpers.isExists(this.selectedMapPointDto)) return;

        if (isX) {
            this.selectedMapPointDto!.positionXPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        } else {
            this.selectedMapPointDto!.positionYPerc = this.$helpers.roundDecimal(percValue! / 100, 2);
        }
    }

    async updateMapRegion() {
        if (!this.$helpers.isExists(this.selectedMapRegionDto)) return;

        let isValid = await this.$validator.validateAll('editMapRegion');

        if (isValid) {
            this.isButtonsDisabled = true;

            mapApi.updateRegion(this.selectedMapRegionDto!, data => {
                if (data.success) {
                    if (data.isAnyChanges) {
                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                            title: "Повідомлення",
                            variant: "info"
                        });
                    }

                    this.updateMapOptions();
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }

    async updateMapDistrict() {
        if (!this.$helpers.isExists(this.selectedMapDistrictDto)) return;

        let isValid = await this.$validator.validateAll('editMapDistrict');

        if (isValid) {
            this.isButtonsDisabled = true;

            mapApi.updateDistrict(this.selectedMapDistrictDto!, data => {
                if (data.success) {
                    if (data.isAnyChanges) {
                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                            title: "Повідомлення",
                            variant: "info"
                        });
                    }

                    this.updateMapOptions();
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }

    async createNewMapPoint() {
        const isDistrictPoint = this.$helpers.isExists(this.selectedMapDistrictDto);

        if (!isDistrictPoint && !this.$helpers.isExists(this.selectedMapRegionDto)) return;

        this.isButtonsDisabled = true;

        let newMapPoint = {
            id: 0,
            mapRegionId: isDistrictPoint ? null : this.selectedMapRegionDto!.id,
            mapDistrictId: isDistrictPoint ? this.selectedMapDistrictDto!.id : null,
            name: 'Новий',
            type: isDistrictPoint? enums.MapElementType_District : enums.MapPointType_Region,
            positionXPerc: 0.5,
            positionYPerc: 0.5,
        };

        // create new
        mapApi.updatePoint(newMapPoint, async data => {
            if (data.success) {
                this.$bvToast.toast("Новий населений пункт створен", {
                    title: "Успіх",
                    variant: "success"
                });

                this.onSelectedMapPointDtoCreated(newMapPoint);

                await this.updateMapDtos();

                this.mapPointId = data.id;
                this.onMapSelectionChanged(false, false);
            } else {
                this.showError()
            }

            this.isButtonsDisabled = false;
        }, errorMessage => {
            this.isButtonsDisabled = false;

            this.showError(errorMessage)
        });
    }

    async updateMapPoint() {
        if (!this.$helpers.isExists(this.selectedMapPointDto)) return;

        let isValid = await this.$validator.validateAll('editMapPoint');

        if (isValid) {
            this.isButtonsDisabled = true;

            const isDistrictPoint = this.$helpers.isNumeric(this.selectedMapPointDto!.mapDistrictId);

            let updatedMapPoint = {
                id: this.selectedMapPointDto!.id,
                mapRegionId: isDistrictPoint ? null : this.selectedMapPointDto!.mapRegionId,
                mapDistrictId: isDistrictPoint ? this.selectedMapPointDto!.mapDistrictId : null,
                name: this.selectedMapPointDto!.name,
                type: this.selectedMapPointDto!.type,
                positionXPerc: this.selectedMapPointDto!.positionXPerc,
                positionYPerc: this.selectedMapPointDto!.positionYPerc,
            };

            mapApi.updatePoint(updatedMapPoint, data => {
                if (data.success) {
                    if (data.isAnyChanges) {
                        this.$bvToast.toast("Зміни успішно збережені", {
                            title: "Успіх",
                            variant: "success"
                        });
                    } else {
                        this.$bvToast.toast("Зміни не потрібні, інформація в актуальному стані", {
                            title: "Повідомлення",
                            variant: "info"
                        });
                    }

                    this.updateMapOptions();
                } else {
                    this.showError()
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }

    async deleteMapPointWithConfirm() {
        if (!this.$helpers.isExists(this.selectedMapPointDto)) return;

        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете видалити населений пункт "${this.$appUtils.getMapElementName(enums.MapElementType_Point, this.selectedMapPointDto!)}"?`, {
            title: "Видалити населений пункт",
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Видалити',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    this.isButtonsDisabled = true;

                    mapApi.deletePoint(this.selectedMapPointDto!.id, async data => {
                        if (data.success) {
                            this.$bvToast.toast("Населений пункт видален", {
                                title: "Успіх",
                                variant: "success"
                            });

                            this.onSelectedMapPointDtoDeleted(this.selectedMapPointDto!);

                            await this.updateMapDtos();

                            this.mapPointId = null;
                            this.onMapSelectionChanged(false, false);
                        } else {
                            this.showError()
                        }

                        this.isButtonsDisabled = false;
                    }, errorMessage => {
                        this.isButtonsDisabled = false;

                        this.showError(errorMessage)
                    });
                }
            })
            .catch(err => {
                // An error occurred
            });
    }
}
